import React from 'react';
import { connect } from 'react-redux';

import { initGoogleAnalytics } from 'analytics/analytics';
import { brazeChangeUser, brazePgaViewEvent } from 'analytics/braze';

import { toggleModal, togglePopup, toggleSpinner, updateMessages, updateReduxAction, toggleSnackBar } from 'actions/appAction';
import { initCalculator } from 'actions/calculatorAction';
import { chatBlockStatus, toggleChat } from 'actions/chatAction';
import { setExtra } from 'actions/extraAction';
import { setNewForm } from 'actions/formAction';
import { updateJsMessages, updatePageMessages } from 'actions/messageAction';

import { UpdateReduxService } from 'services/UpdateReduxService';

import { COUNTRY_OF_RESIDENCE } from 'constants/amplitude/AmplitudeParamName';

import update from 'helpers/Immutability';

import amplitude from 'amplitude-js';

import { AMPLITUDE_API_KEY } from './AmplitudeUtils';
import WSChat from '../chat/WSChat';

export default function BasePageForNoAuth(PageComponent) {
    class BasePageForNoAuth extends React.Component {
        constructor(props) {
            super(props);

            this.updateReduxService = new UpdateReduxService(props.lang);
            this.updateReduxService.setMessageAction(props.updateJsMessages, props.updatePageMessages);
            this.updateReduxService.setChatAction(props.chatBlockStatus);
            this.updateReduxService.setFormAction(props.setNewForm);
            this.updateReduxService.setCalculatorAction(props.initCalculator);
            this.updateReduxService.setAppAction(props.toggleModal, props.togglePopup, props.toggleSpinner, props.updateMessages);
            this.updateReduxService.setExtraAction(props.setExtra);
            this.updateReduxService.setStateOptions(props.stateOptions);

            const data = __isBrowser__ ? window.__INITIAL_DATA__ : props.staticContext ? props.staticContext.json : props.data;

            this.state = { data: data, loading: props.updateRedux };
        }

        componentDidMount() {
            if (this.props.updateRedux) {
                this.updateReduxService.fetchData(this.props.lang, this.props.isAuthZone, this.props.country).then((data) => {
                    this.setState(
                        update(this.state, {
                            data: { $set: data },
                            loading: { $set: false },
                        }),
                    );
                });
            } else {
                this.props.updateReduxAction();
            }
            window.scrollTo(0, 0);
            if (__isBrowser__) {
                if (document.readyState === 'complete') {
                    this.initAnalytics();
                } else {
                    window.addEventListener('load', this.initAnalytics, { once: true });
                }
            }
            if (__isProd__) {
                const userId = this.props.auth?.phone ? this.props.auth?.phone : null;
                const userCountry = this.props.userCountry?.nameEn;
                amplitude.getInstance().init(AMPLITUDE_API_KEY, userId, {
                    serverZone: 'EU',
                    serverZoneBasedApi: true,
                });
                if (userCountry) {
                    amplitude.getInstance().setUserProperties({ [COUNTRY_OF_RESIDENCE]: userCountry });
                }
            } else {
                amplitude.getInstance = () => {
                    return {
                        setUserId: () => {},
                        setUserProperties: () => {},
                        logEvent: () => {},
                    };
                };
            }
            if (__isBrowser__) {
                brazePgaViewEvent(window.location.href, document.title, this.props.app, this.props.auth, this.props.lang);
                if (this.props.auth?.ballId) {
                    brazeChangeUser(this.props.auth?.ballId);
                } else {
                    sessionStorage?.removeItem('isLoggedIn');
                }
            }
        }

        componentDidUpdate(prevProps) {
            if (this.props.lang !== prevProps.lang) {
                this.updateReduxService.fetchData(this.props.lang, this.props.isAuthZone, this.props.country);
            }
        }

        initAnalytics = () => {
            const activateAnalytics = __isProd__;
            initGoogleAnalytics(activateAnalytics);
        };

        render() {
            return (
                <>
                    <PageComponent {...this.props} loading={this.state.loading} data={this.state.data} />
                    {this.props.stateOptions?.showChat && <WSChat />}
                </>
            );
        }
    }

    const mapStateToProps = (state) => {
        return {
            app: state.app,
            updateRedux: state.app.updateRedux,
            auth: state.auth,
            lang: state.language.lang,
            country: state.app.country,
            showBrexitTerms: state.extra.showBrexitTerms,
            userCountry: state.extra?.userCountry,
        };
    };

    return connect(mapStateToProps, {
        updateReduxAction,
        togglePopup,
        toggleModal,
        updatePageMessages,
        updateJsMessages,
        setNewForm,
        initCalculator,
        updateMessages,
        toggleSpinner,
        setExtra,
        chatBlockStatus,
        toggleChat,
        toggleSnackBar,
    })(BasePageForNoAuth);
}
